<template>
  <v-app>
    <sidebar/>

    <app-bar/>

    <v-main>
      <v-container fluid>
        <router-view/>
      </v-container>
    </v-main>

    <v-footer
        inset
        app
    >
      <span class="px-4">&copy; {{ new Date().getFullYear() }}</span>
    </v-footer>

    <v-snackbar
        v-on:close="snackbar.onClose"
        v-model="snackbar.show"
        timeout="5000"
        :color="snackbar.color"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar.onClick"
        >
          Ver
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import Sidebar from "@/components/Sidebar"
import AppBar from "@/components/AppBar"
import {mapState} from 'vuex'

export default {
  name: 'Admin',
  components: {Sidebar, AppBar},
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  methods: {
    showNotification: function(message, color, callbacks) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
      this.snackbar.onClick = callbacks.onClick
      this.snackbar.onClose = callbacks.onClose
    },
  },
  data: () => ({
    notifications: {},
    snackbar: {
      text: '',
      show: false,
      color: 'info',
      onClick: () => {},
      onClose: () => {},
    }
  })
}
</script>
